import { FC, useCallback, useMemo } from 'react';
import { Stack } from '@mui/material';

import { useStoryCrud } from '../hooks/useStoryCrud';
import { useStory } from '../hooks/useStory';

import { FormCrud, StoryForm } from './StoryForm/StoryForm';
import { StoryHeader } from './StoryHeader';


interface ViewProps {
  onSuccess?: (story: Stories.Story) => void;
  storyId: number;
}

export const EditStoryPartial: FC<ViewProps> = (props) => {
  const { onSuccess, storyId } = props;

  const { story } = useStory({ id: storyId });

  const { editStory } = useStoryCrud();

  const onSubmit = useCallback(async (data: FormCrud) => {
    try {
      const response = await editStory.mutateAsync(data as Stories.Edit);

      onSuccess?.(response.data);
    } catch (error) {
      console.error(error);
    }
  }, [editStory, onSuccess]);

  const defaultValues: Partial<FormCrud> = useMemo(() => {
    const { user, ...rest } = story || ({} as Stories.Story);
    return {
      ...rest,
    };
  }, [story]);

  return (
    <Stack gap={2} width="100%">
      <StoryHeader title="Edit Story" isSaving={editStory.isPending}/>
      <StoryForm
        onSubmitRequest={onSubmit}
        defaultValues={defaultValues}
      />
    </Stack>
  );
};
